var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("form-item-check-box", {
        attrs: {
          label: "宛先(TO)",
          "form-label-class-name": "pega-form-label-important",
          items: _vm.recipient.to,
        },
      }),
      _vm._v(" "),
      _c("form-item-check-box", {
        attrs: {
          label: "宛先(CC)",
          "form-label-class-name": "pega-form-label-important",
          items: _vm.recipient.cc,
        },
        on: { delete: _vm.deleteNotificationAccount },
        scopedSlots: _vm._u([
          {
            key: "footer",
            fn: function () {
              return [
                _vm.isCompanyStaffAccess
                  ? _c("small", { attrs: { "data-test": "cc-message" } }, [
                      _vm._v(
                        "※アカウントを発行すると宛先(CC)に追加されます。アカウント管理は、設定管理者のみ行えます。"
                      ),
                    ])
                  : [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.name,
                            expression: "name",
                          },
                        ],
                        staticClass: "boss-input pega-height-35",
                        attrs: {
                          type: "text",
                          "data-test": "input-name",
                          size: "30",
                          placeholder: "名前",
                        },
                        domProps: { value: _vm.name },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.name = $event.target.value
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.email,
                            expression: "email",
                          },
                        ],
                        staticClass: "boss-input pega-height-35",
                        attrs: {
                          type: "text",
                          "data-test": "input-email",
                          size: "60",
                          placeholder: "メールアドレス",
                        },
                        domProps: { value: _vm.email },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.email = $event.target.value
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "pega-mt-05" }, [
                        _c(
                          "button",
                          {
                            staticClass:
                              "boss-button pega-button boss-button-center",
                            attrs: {
                              disabled: _vm.isAddButtonDisabled,
                              "data-test": "add-account",
                            },
                            on: { click: _vm.registerNotificationAccount },
                          },
                          [_vm._v("\n            追加\n          ")]
                        ),
                      ]),
                    ],
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _vm._v(" "),
      _c("form-item-text-area", {
        attrs: {
          "form-label-class-name": "pega-form-label-important",
          "class-name": _vm.isOverLengthBody
            ? "boss-send-textarea is-invalid-input"
            : "boss-send-textarea",
          rows: "",
        },
        scopedSlots: _vm._u([
          {
            key: "label",
            fn: function () {
              return [
                _vm._v("\n      メッセージ"),
                _c("br"),
                _vm._v(" "),
                _c("small", [_vm._v("（2,000文字以内）")]),
              ]
            },
            proxy: true,
          },
          {
            key: "error",
            fn: function () {
              return [
                _vm.isOverLengthBody
                  ? _c("validation-label", {
                      attrs: { label: "本文は2000文字以内で入力してください" },
                    })
                  : _vm._e(),
              ]
            },
            proxy: true,
          },
        ]),
        model: {
          value: _vm.messageBody,
          callback: function ($$v) {
            _vm.messageBody = $$v
          },
          expression: "messageBody",
        },
      }),
      _vm._v(" "),
      _c(
        "form-button-area",
        [
          _c("form-confirm-button", {
            attrs: {
              "is-disabled": _vm.isSendButtonDisabled,
              "button-class": "pega-confirm-important",
              "submit-label": "メッセージを送信する",
            },
            on: { "submit-event": _vm.submit },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }